import {createSetNodeAttributeCommand} from "./createSetNodeAttributeCommand";


export const setViewSizeSmall = createSetNodeAttributeCommand('display', 'small');
export const setViewSizeNormal = createSetNodeAttributeCommand('display', 'normal');
export const setViewSizeLarge = createSetNodeAttributeCommand('display', 'large');
